"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CACHE_PREFIX = 'harry:';
// cached for 60 minutes as things rarely change
var CACHE_DURATION = 60;
function SDK(baseUrl, fetch, cacheInterface) {
  function _fetchJson(url) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, overrideBaseUrl, logger, res, data, _res, _data, text;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      overrideBaseUrl = $args.length > 2 ? $args[2] : undefined;
      logger = $args.length > 3 && $args[3] !== undefined ? $args[3] : console;
      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'content-type', 'application/json'));
      }
      // some of the sdks are used in the browswer where the native fetch is used.
      if (typeof window === 'undefined') {
        options.responseType = 'json';
        var $Try_1_Post = function () {
          try {
            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this);
        var $Try_1_Catch = function (error) {
          try {
            data = error.response.body;
            throw _objectSpread({
              status: error.statusCode
            }, data);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };
        try {
          return Promise.resolve(fetch("".concat(overrideBaseUrl ? overrideBaseUrl : baseUrl).concat(url), options)).then(function ($await_5) {
            try {
              res = $await_5;
              return $return(res.body);
            } catch ($boundEx) {
              return $Try_1_Catch($boundEx);
            }
          }, $Try_1_Catch);
        } catch (error) {
          $Try_1_Catch(error)
        }
      } else {
        return Promise.resolve(fetch("".concat(overrideBaseUrl ? overrideBaseUrl : baseUrl).concat(url), options)).then(function ($await_6) {
          try {
            _res = $await_6;
            if (_res.ok) {
              return Promise.resolve(_res.json()).then($return, $error);
            } else {
              if (_res.headers.get('Content-Type').indexOf('application/json') !== -1) {
                return Promise.resolve(_res.json()).then(function ($await_8) {
                  try {
                    _data = $await_8;
                    logger.error({
                      status: _res.status,
                      data: _data
                    }, 'unsuccessful request to harry.');
                    return $error(_objectSpread({
                      status: _res.status
                    }, _data));
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }, $error);
              }
              return Promise.resolve(_res.text()).then(function ($await_9) {
                try {
                  text = $await_9;
                  logger.error({
                    status: _res.status,
                    text: text
                  }, 'unsuccessful request to harry.');
                  return $error(text);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            }
            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }
      function $If_2() {
        return $return();
      }
    });
  }
  var _getKey = function _getKey(key) {
    return cacheInterface.getKey(CACHE_PREFIX, key);
  };
  var _cacheGet = function _cacheGet(key) {
    return new Promise(function ($return, $error) {
      return Promise.resolve(cacheInterface.get(_getKey(key))).then($return, $error);
    });
  };
  var _cacheSet = function _cacheSet(key, value, duration) {
    return cacheInterface.set({
      key: _getKey(key),
      value: value,
      lifetimeMins: duration ? duration : CACHE_DURATION
    });
  };
  // const _cacheClearByKeyStartsWith = async ( partialKey ) => cacheInterface.clearByKeyStartsWith( _getKey( partialKey ) );
  var _clearByKey = function _clearByKey(key) {
    return cacheInterface.clearByKey(_getKey(key));
  };
  var getCountries = function getCountries() {
    return new Promise(function ($return, $error) {
      var key, cached, response;
      key = 'countries';
      return Promise.resolve(_cacheGet(key)).then(function ($await_11) {
        try {
          cached = $await_11;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_fetchJson('/countries')).then(function ($await_12) {
            try {
              response = $await_12;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var getGeographicalRegions = function getGeographicalRegions(countryId) {
    return new Promise(function ($return, $error) {
      var key, cached, response;
      key = "countries-".concat(countryId, "-regions");
      return Promise.resolve(_cacheGet(key)).then(function ($await_13) {
        try {
          cached = $await_13;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_fetchJson("/countries/".concat(countryId, "/geographical-regions"))).then(function ($await_14) {
            try {
              response = $await_14;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var getCurrencies = function getCurrencies() {
    return new Promise(function ($return, $error) {
      var key, cached, response;
      key = 'currencies';
      return Promise.resolve(_cacheGet(key)).then(function ($await_15) {
        try {
          cached = $await_15;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_fetchJson('/currencies')).then(function ($await_16) {
            try {
              response = $await_16;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var getCategories = function getCategories() {
    return new Promise(function ($return, $error) {
      var key, cached, response;
      key = 'categories';
      return Promise.resolve(_cacheGet(key)).then(function ($await_17) {
        try {
          cached = $await_17;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_fetchJson('/categories')).then(function ($await_18) {
            try {
              response = $await_18;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var createCategories = function createCategories(values) {
    return new Promise(function ($return, $error) {
      var response = _fetchJson('/categories', {
        method: 'POST',
        body: JSON.stringify({
          values: values
        })
      });
      _clearByKey('categories');
      return $return(response);
    });
  };
  var removeCategory = function removeCategory(category) {
    return new Promise(function ($return, $error) {
      var response = _fetchJson("/categories/".concat(category), {
        method: 'DELETE'
      });
      _clearByKey('categories');
      return $return(response);
    });
  };
  var getDomains = function getDomains() {
    return new Promise(function ($return, $error) {
      var key, cached, response;
      key = 'domains';
      return Promise.resolve(_cacheGet(key)).then(function ($await_19) {
        try {
          cached = $await_19;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_fetchJson('/domains')).then(function ($await_20) {
            try {
              response = $await_20;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var createDomains = function createDomains(values) {
    return new Promise(function ($return, $error) {
      var response = _fetchJson('/domains', {
        method: 'POST',
        body: JSON.stringify({
          values: values
        })
      });
      _clearByKey('domains');
      return $return(response);
    });
  };
  var removeDomain = function removeDomain(domain) {
    return new Promise(function ($return, $error) {
      var response = _fetchJson("/domains/".concat(domain), {
        method: 'DELETE'
      });
      _clearByKey('domains');
      return $return(response);
    });
  };
  var getTriggers = function getTriggers() {
    return new Promise(function ($return, $error) {
      var key, cached, response;
      key = 'triggers';
      return Promise.resolve(_cacheGet(key)).then(function ($await_21) {
        try {
          cached = $await_21;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_fetchJson('/triggers')).then(function ($await_22) {
            try {
              response = $await_22;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var createTriggers = function createTriggers(values) {
    return new Promise(function ($return, $error) {
      var response = _fetchJson('/triggers', {
        method: 'POST',
        body: JSON.stringify({
          values: values
        })
      });
      _clearByKey('triggers');
      return $return(response);
    });
  };
  var removeTrigger = function removeTrigger(trigger) {
    return new Promise(function ($return, $error) {
      var response = _fetchJson("/triggers/".concat(trigger), {
        method: 'DELETE'
      });
      _clearByKey('triggers');
      return $return(response);
    });
  };
  var getTimezones = function getTimezones() {
    return new Promise(function ($return, $error) {
      var key, cached, response;
      key = 'timezones';
      return Promise.resolve(_cacheGet(key)).then(function ($await_23) {
        try {
          cached = $await_23;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_fetchJson('/timezones')).then(function ($await_24) {
            try {
              response = $await_24;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var getDataTypes = function getDataTypes() {
    return new Promise(function ($return, $error) {
      var key, cached, response;
      key = 'data-types';
      return Promise.resolve(_cacheGet(key)).then(function ($await_25) {
        try {
          cached = $await_25;
          if (cached) {
            return $return(cached);
          }
          return Promise.resolve(_fetchJson('/dataTypes')).then(function ($await_26) {
            try {
              response = $await_26;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var createDataTypes = function createDataTypes(values) {
    return new Promise(function ($return, $error) {
      var response = _fetchJson('/dataTypes', {
        method: 'POST',
        body: JSON.stringify({
          values: values
        })
      });
      _clearByKey('data-types');
      return $return(response);
    });
  };
  var removeDataType = function removeDataType(dateType) {
    return new Promise(function ($return, $error) {
      var response = _fetchJson("/dataTypes/".concat(dateType), {
        method: 'DELETE'
      });
      _clearByKey('data-types');
      return $return(response);
    });
  };
  return {
    getCountries: getCountries,
    getGeographicalRegions: getGeographicalRegions,
    getCurrencies: getCurrencies,
    getCategories: getCategories,
    createCategories: createCategories,
    removeCategory: removeCategory,
    getTriggers: getTriggers,
    createTriggers: createTriggers,
    removeTrigger: removeTrigger,
    getTimezones: getTimezones,
    getDataTypes: getDataTypes,
    createDataTypes: createDataTypes,
    removeDataType: removeDataType,
    getDomains: getDomains,
    createDomains: createDomains,
    removeDomain: removeDomain
  };
}
var noCache = {
  getKey: function getKey() {
    return '';
  },
  get: function get() {
    return new Promise(function ($return, $error) {
      return $return(undefined);
    });
  },
  set: function set(_ref) {
    var key = _ref.key,
      value = _ref.value,
      lifetimeMins = _ref.lifetimeMins;
    return value;
  },
  clear: function clear() {
    return undefined;
  },
  clearByKey: function clearByKey() {
    return undefined;
  },
  clearByKeyStartsWith: function clearByKeyStartsWith() {
    return undefined;
  }
};
module.exports = function (url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;
  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }
  return new SDK(url, customFetch, cacheInterface);
};
//# sourceMappingURL=index.js.map